import { useState } from "react";
import {
  TextField,
  Box,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
  Autocomplete,
} from "@mui/material";
import { rsActiveMenu, rsGotoLast, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import Detail from "../../main/detail/Detail";
import { UseCustomerRetention } from "./UseCustomerRetention";
import { useLocation, useNavigate } from "react-router-dom";
import { removeComma, toMoney } from "../../util/Utils";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function AddPattern() {
  var MonthArray = Array.from({ length: 24 }, (_, i) => i + 1);
  var CountArray = Array.from({ length: 10 }, (_, i) => i + 1);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const { isSmall } = useBreakpoints();

  const [progress, setProgress] = useRecoilState(rsProgress);
  const { validate, addPattern } = UseCustomerRetention();
  const [state, setState] = useState({
    title: undefined,
    period: 0,
    autoCreate: false,
    activeCode: false,
    lastOrder: 0,
    lastOrderScale: undefined,
    reminderCount: 0,
    reminderCountScale: undefined,
    totalOrderCost: 0,
    totalOrderCostScale: undefined,
    averageOrderCost: 0,
    averageOrderCostScale: undefined,
    totalOrderCount: 0,
    totalOrderCountScale: undefined,
    totalDirectDiscount: 0,
    totalDirectDiscountScale: undefined,
    totalUsedDiscountCode: 0,
    totalUsedDiscountCodeScale: undefined,
  });

  const [errorState, setErrorState] = useState({
    title: false,
  });

  const LessMore = [
    { id: 1, value: "بیشتر", scale: true },
    { id: 2, value: "کمتر", scale: false },
  ];

  return (
    <Detail
      breadChilds={{
        title: "مارکتینگ",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/customerretention" },
          { name: "افزودن الگو", url: "/customerretention/addPattern" },
        ],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 2 }}>
        <TextField
          sx={{ width: isSmall ? "100%" : "30%" }}
          label="عنوان"
          error={errorState.title}
          value={state.title ? state.title : ""}
          onChange={(evt) => {
            setState({ ...state, title: evt.target.value });
          }}
          size="small"
          variant="outlined"
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmall ? "column" : "row",
            alignItems: isSmall ? "flex-start" : "center",
            gap: 1,
          }}
        >
          <Typography
            color="secondary"
            // color="secondary"
            variant="subtitle1"
          >
            بازه محاسبات :
          </Typography>
          <Autocomplete
            size="small"
            value={state.period ? state.period : ""}
            onChange={(event, newValue) => {
              if (newValue) {
                setState({
                  ...state,
                  period: newValue,
                });
              } else {
                setState({
                  ...state,
                  period: undefined,
                });
              }
            }}
            isOptionEqualToValue={(option, value) => {
              return value == "" || option === value;
            }}
            getOptionLabel={(option) => {
              if (option) {
                return MonthArray?.find((m) => m == option).toString();
              }
              return "";
            }}
            sx={{ width: isSmall ? "100%" : "15%" }}
            options={MonthArray ? MonthArray.map((m) => m) : []}
            renderInput={(params) => (
              <TextField
                sx={{ input: { textAlign: "center" } }}
                variant="outlined"
                {...params}
                label="ماه"
              />
            )}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmall ? "column" : "row",
            alignItems: isSmall ? "flex-start" : "center",
            gap: 1,
          }}
        >
          <Typography color="secondary" variant="subtitle1">
            آخرین سفارش :
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: isSmall ? "100%" : "80%",
            }}
          >
            <Autocomplete
              size="small"
              value={
                state.lastOrderScale !== undefined
                  ? state.lastOrderScale == true
                    ? 1
                    : 2
                  : ""
              }
              onChange={(event, newValue) => {
                if (newValue == 1) {
                  setState({
                    ...state,
                    lastOrderScale: true,
                  });
                } else if (newValue == 2) {
                  setState({
                    ...state,
                    lastOrderScale: false,
                  });
                } else {
                  setState({
                    ...state,
                    lastOrderScale: undefined,
                  });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return LessMore?.find((m) => m.id == option).value;
                }
                return "";
              }}
              sx={{ width: isSmall ? "100%" : "15%" }}
              options={LessMore.map((m) => m.id)}
              renderInput={(params) => (
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  {...params}
                  label="مقیاس"
                />
              )}
            />
            <Typography color="secondary" variant="subtitle1">
              از
            </Typography>
            <TextField
              sx={{
                input: {
                  textAlign: "center",
                },
                width: isSmall ? "100%" : "15%",
              }}
              label="روز"
              value={state.lastOrder ? state.lastOrder : ""}
              onChange={(evt) => {
                setState({
                  ...state,
                  lastOrder: Number(evt.target.value),
                });
              }}
              size="small"
              variant="outlined"
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmall ? "column" : "row",
            alignItems: isSmall ? "flex-start" : "center",
            gap: 1,
          }}
        >
          <Typography color="secondary" variant="subtitle1">
            کد تخفیف ارسال شده :
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: isSmall ? "100%" : "80%",
            }}
          >
            <Autocomplete
              size="small"
              value={
                state.reminderCountScale !== undefined
                  ? state.reminderCountScale == true
                    ? 1
                    : 2
                  : ""
              }
              onChange={(event, newValue) => {
                if (newValue == 1) {
                  setState({
                    ...state,
                    reminderCountScale: true,
                  });
                } else if (newValue == 2) {
                  setState({
                    ...state,
                    reminderCountScale: false,
                  });
                } else {
                  setState({
                    ...state,
                    reminderCountScale: undefined,
                  });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return LessMore?.find((m) => m.id == option).value;
                }
                return "";
              }}
              sx={{ width: isSmall ? "100%" : "15%" }}
              options={LessMore.map((m) => m.id)}
              renderInput={(params) => (
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  {...params}
                  label="مقیاس"
                />
              )}
            />
            <Typography color="secondary" variant="subtitle1">
              از
            </Typography>
            <Autocomplete
              size="small"
              value={state.reminderCount ? state.reminderCount : ""}
              onChange={(event, newValue) => {
                if (newValue) {
                  setState({
                    ...state,
                    reminderCount: newValue,
                  });
                } else {
                  setState({
                    ...state,
                    reminderCount: undefined,
                  });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return CountArray?.find((m) => m == option).toString();
                }
                return "";
              }}
              sx={{ width: isSmall ? "100%" : "15%" }}
              options={CountArray ? CountArray.map((m) => m) : []}
              renderInput={(params) => (
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  {...params}
                  label="تعداد"
                />
              )}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmall ? "column" : "row",
            alignItems: isSmall ? "flex-start" : "center",
            gap: 1,
          }}
        >
          <Typography color="secondary" variant="subtitle1">
            مجموع خرید :
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: isSmall ? "100%" : "80%",
            }}
          >
            <Autocomplete
              size="small"
              value={
                state.totalOrderCostScale !== undefined
                  ? state.totalOrderCostScale == true
                    ? 1
                    : 2
                  : ""
              }
              onChange={(event, newValue) => {
                if (newValue == 1) {
                  setState({
                    ...state,
                    totalOrderCostScale: true,
                  });
                } else if (newValue == 2) {
                  setState({
                    ...state,
                    totalOrderCostScale: false,
                  });
                } else {
                  setState({
                    ...state,
                    totalOrderCostScale: undefined,
                  });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return LessMore?.find((m) => m.id == option).value;
                }
                return "";
              }}
              sx={{ width: isSmall ? "100%" : "15%" }}
              options={LessMore.map((m) => m.id)}
              renderInput={(params) => (
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  {...params}
                  label="مقیاس"
                />
              )}
            />
            <Typography color="secondary" variant="subtitle1">
              از
            </Typography>
            <TextField
              sx={{
                input: {
                  textAlign: "center",
                },
                width: isSmall ? "100%" : "15%",
              }}
              label="تومان"
              value={state.totalOrderCost ? toMoney(state.totalOrderCost) : ""}
              onChange={(evt) => {
                if (evt.target.value) {
                  setState({
                    ...state,
                    totalOrderCost: Number(removeComma(evt.target.value)),
                  });
                } else {
                  setState({
                    ...state,
                    totalOrderCost: 0,
                  });
                }
              }}
              size="small"
              variant="outlined"
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmall ? "column" : "row",
            alignItems: isSmall ? "flex-start" : "center",
            gap: 1,
          }}
        >
          <Typography color="secondary" variant="subtitle1">
            میانگین خرید :
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: isSmall ? "100%" : "80%",
            }}
          >
            <Autocomplete
              size="small"
              value={
                state.averageOrderCostScale !== undefined
                  ? state.averageOrderCostScale == true
                    ? 1
                    : 2
                  : ""
              }
              onChange={(event, newValue) => {
                if (newValue == 1) {
                  setState({
                    ...state,
                    averageOrderCostScale: true,
                  });
                } else if (newValue == 2) {
                  setState({
                    ...state,
                    averageOrderCostScale: false,
                  });
                } else {
                  setState({
                    ...state,
                    averageOrderCostScale: undefined,
                  });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return LessMore?.find((m) => m.id == option).value;
                }
                return "";
              }}
              sx={{ width: isSmall ? "100%" : "15%" }}
              options={LessMore.map((m) => m.id)}
              renderInput={(params) => (
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  {...params}
                  label="مقیاس"
                />
              )}
            />
            <Typography color="secondary" variant="subtitle1">
              از
            </Typography>
            <TextField
              sx={{
                input: {
                  textAlign: "center",
                },
                width: isSmall ? "100%" : "15%",
              }}
              label="تومان"
              value={
                state.averageOrderCost ? toMoney(state.averageOrderCost) : ""
              }
              onChange={(evt) => {
                if (evt.target.value) {
                  setState({
                    ...state,
                    averageOrderCost: Number(removeComma(evt.target.value)),
                  });
                } else {
                  setState({
                    ...state,
                    averageOrderCost: 0,
                  });
                }
              }}
              size="small"
              variant="outlined"
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmall ? "column" : "row",
            alignItems: isSmall ? "flex-start" : "center",
            gap: 1,
          }}
        >
          <Typography color="secondary" variant="subtitle1">
            تعداد سفارشات :
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: isSmall ? "100%" : "80%",
            }}
          >
            <Autocomplete
              size="small"
              value={
                state.totalOrderCountScale !== undefined
                  ? state.totalOrderCountScale == true
                    ? 1
                    : 2
                  : ""
              }
              onChange={(event, newValue) => {
                if (newValue == 1) {
                  setState({
                    ...state,
                    totalOrderCountScale: true,
                  });
                } else if (newValue == 2) {
                  setState({
                    ...state,
                    totalOrderCountScale: false,
                  });
                } else {
                  setState({
                    ...state,
                    totalOrderCountScale: undefined,
                  });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return LessMore?.find((m) => m.id == option).value;
                }
                return "";
              }}
              sx={{ width: isSmall ? "100%" : "15%" }}
              options={LessMore.map((m) => m.id)}
              renderInput={(params) => (
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  {...params}
                  label="مقیاس"
                />
              )}
            />
            <Typography color="secondary" variant="subtitle1">
              از
            </Typography>
            <TextField
              sx={{
                input: {
                  textAlign: "center",
                },
                width: isSmall ? "100%" : "15%",
              }}
              label="تعداد"
              value={state.totalOrderCount ? state.totalOrderCount : ""}
              onChange={(evt) => {
                if (evt.target.value) {
                  setState({
                    ...state,
                    totalOrderCount: Number(evt.target.value),
                  });
                } else {
                  setState({
                    ...state,
                    totalOrderCount: 0,
                  });
                }
              }}
              size="small"
              variant="outlined"
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmall ? "column" : "row",
            alignItems: isSmall ? "flex-start" : "center",
            gap: 1,
          }}
        >
          <Typography color="secondary" variant="subtitle1">
            تخفیف مستقیم :
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: isSmall ? "100%" : "80%",
            }}
          >
            <Autocomplete
              size="small"
              value={
                state.totalDirectDiscountScale !== undefined
                  ? state.totalDirectDiscountScale == true
                    ? 1
                    : 2
                  : ""
              }
              onChange={(event, newValue) => {
                if (newValue == 1) {
                  setState({
                    ...state,
                    totalDirectDiscountScale: true,
                  });
                } else if (newValue == 2) {
                  setState({
                    ...state,
                    totalDirectDiscountScale: false,
                  });
                } else {
                  setState({
                    ...state,
                    totalDirectDiscountScale: undefined,
                  });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return LessMore?.find((m) => m.id == option).value;
                }
                return "";
              }}
              sx={{ width: isSmall ? "100%" : "15%" }}
              options={LessMore.map((m) => m.id)}
              renderInput={(params) => (
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  {...params}
                  label="مقیاس"
                />
              )}
            />
            <Typography color="secondary" variant="subtitle1">
              از
            </Typography>
            <TextField
              sx={{
                input: {
                  textAlign: "center",
                },
                width: isSmall ? "100%" : "15%",
              }}
              label="تومان"
              value={
                state.totalDirectDiscount
                  ? toMoney(state.totalDirectDiscount)
                  : ""
              }
              onChange={(evt) => {
                if (evt.target.value) {
                  setState({
                    ...state,
                    totalDirectDiscount: Number(removeComma(evt.target.value)),
                  });
                } else {
                  setState({
                    ...state,
                    totalDirectDiscount: 0,
                  });
                }
              }}
              size="small"
              variant="outlined"
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmall ? "column" : "row",
            alignItems: isSmall ? "flex-start" : "center",
            gap: 1,
          }}
        >
          <Typography color="secondary" variant="subtitle1">
            استفاده کد تخفیف :
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: isSmall ? "100%" : "80%",
            }}
          >
            <Autocomplete
              size="small"
              value={
                state.totalUsedDiscountCodeScale !== undefined
                  ? state.totalUsedDiscountCodeScale == true
                    ? 1
                    : 2
                  : ""
              }
              onChange={(event, newValue) => {
                if (newValue == 1) {
                  setState({
                    ...state,
                    totalUsedDiscountCodeScale: true,
                  });
                } else if (newValue == 2) {
                  setState({
                    ...state,
                    totalUsedDiscountCodeScale: false,
                  });
                } else {
                  setState({
                    ...state,
                    totalUsedDiscountCodeScale: undefined,
                  });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return LessMore?.find((m) => m.id == option).value;
                }
                return "";
              }}
              sx={{ width: isSmall ? "100%" : "15%" }}
              options={LessMore.map((m) => m.id)}
              renderInput={(params) => (
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  {...params}
                  label="مقیاس"
                />
              )}
            />
            <Typography color="secondary" variant="subtitle1">
              از
            </Typography>
            <TextField
              sx={{
                input: {
                  textAlign: "center",
                },
                width: isSmall ? "100%" : "15%",
              }}
              label="تعداد"
              value={
                state.totalUsedDiscountCode ? state.totalUsedDiscountCode : ""
              }
              onChange={(evt) => {
                if (evt.target.value) {
                  setState({
                    ...state,
                    totalUsedDiscountCode: Number(evt.target.value),
                  });
                } else {
                  setState({
                    ...state,
                    totalUsedDiscountCode: 0,
                  });
                }
              }}
              size="small"
              variant="outlined"
            />
          </Box>
        </Box>
        <Box>
          <FormControlLabel
            control={
              <Checkbox
                checked={state.activeCode}
                onChange={(evt) => {
                  setState({
                    ...state,
                    activeCode: evt.target.checked,
                  });
                }}
              />
            }
            label="کد تخفیف فعال نداشته باشد"
          />
        </Box>
        <Box>
          <FormControlLabel
            control={
              <Checkbox
                checked={state.autoCreate}
                onChange={(evt) => {
                  setState({
                    ...state,
                    autoCreate: evt.target.checked,
                  });
                }}
              />
            }
            label="تولید اتوماتیک روزانه"
          />
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            color="secondary"
            onClick={() => {
              if (validate(state, setErrorState) == 200) {
                setProgress(true);
                setMsGotoLast(true);
                addPattern(state, () => {
                  navigate("/customerretention", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                });
              }
            }}
          >
            ثبت
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              navigate("/customerretention", {
                state: { ...location.state, isBack: true },
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
